module.exports = __webpack_public_path__ + "static/media/bg.96ae5c2a.jpg";